import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { allExpanded, defaultStyles, JsonView } from "react-json-view-lite";

// components
import { AccordionStyled } from "./accordion";


export const AdminPerfomance = ({ selectedResult }) => {
  return (
    <AccordionStyled title={"Admin"} expandedDefault={false}>
      <Box>
        {selectedResult && selectedResult.timings && (
          <Box>
            <Typography fontWeight={600} mb='8px'>Timings:</Typography>
            {Object.entries(selectedResult.timings).map(([key, value]) => (
              <Box key={key}>
                <Typography fontSize={'14px'}>{key}: <Typography variant="span" fontWeight={500}>{value}</Typography></Typography>
                
              </Box>
            ))}
          </Box>
        )}
        {selectedResult && selectedResult.objective_function && (
          <Box
            sx={{
              mt: '16px',
              ul: {
                paddingInlineStart: "10px",
                fontSize: '14px'
              },
              
            }}
          >
            <Typography fontWeight={600} mb='8px'>Objective function:</Typography>
            <JsonView
              data={selectedResult.objective_function}
              shouldExpandNode={allExpanded}
              style={defaultStyles}
            />
          </Box>
        )}
      </Box>
    </AccordionStyled>
  );
};
